import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Thumbnail } from '../../partials/image/image.types';
import { Image } from '../../partials/image/Image';
import { useTheme } from '../../../theming/useTheme';
import { ErrorBoundary } from '../../errorHandling/ErrorBoundary';
import { MEDIA_BREAKPOINTS } from '../../../mediaQueries.const';
import { createStyleForBoxShadow } from '../../../theming/boxShadow';
import { BaseUnit } from '../../../theming/baseUnitDefinition';
import { createImageWidths } from '../../partials/image/image.utils';

const componentConfigThemeKey = 'authorImage';

interface AuthorImageDataProps {
  image: Thumbnail;
}

interface AuthorImageThemeProps {
  baseUnit: BaseUnit;
  boxShadowTypeNormal: string;
}

const getStyle = (baseUnit: BaseUnit) => StyleSheet.create({
  wrapper: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: '100%',
    marginLeft: 'auto',
    marginRight: 'auto',
    boxSizing: 'border-box',
    border: '5px solid white',
    marginTop: `${baseUnit * 2}px`,
    [MEDIA_BREAKPOINTS.large]: {
      width: '160px',
      height: '160px',
    },
    [MEDIA_BREAKPOINTS.medium]: {
      width: '120px',
      height: '120px',
    },
    [MEDIA_BREAKPOINTS.small]: {
      width: '120px',
      height: '120px',
    },
  },
});

const imageWidths = createImageWidths(180, 180, 180);

export const AuthorImage: React.FunctionComponent<AuthorImageDataProps> = props => {
  const { image } = props;
  const { baseUnit, boxShadowTypeNormal } = useTheme<AuthorImageThemeProps>(componentConfigThemeKey);
  const style = getStyle(baseUnit);
  const aspectRatio = { x: 1, y: 1 };
  const boxShadowStyle = createStyleForBoxShadow({ boxShadowTypeNormal });

  return (
    <ErrorBoundary>
      <div className={css(boxShadowStyle.style, style.wrapper)}>
        <Image {...image} aspectRatio={aspectRatio} imageWidths={imageWidths} />
      </div>
    </ErrorBoundary>
  );
};
